import TYPES from '@/store/types'

const mutations = {

}

export default mutations
